import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const MIRAMARWATERLINES_LAYER_ID = 'miramarWaterLinesLayer';

const layerConfig = {
  title: 'Water Main Lines',
};

function MiramarWaterLinesLayer() {
  const dispatch = useDispatch();
  const { miramarWaterLinesLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarWaterLinesLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarWaterLinesLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARWATERLINES_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarWaterLinesLayer.visible,
      opacity: miramarWaterLinesLayer.opacity,

      getLineColor: [0, 134, 149],
      lineWidthMinPixels: 2,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARWATERLINES_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Water Line Details',
              includeColumns: [
                'Water_Line_Type',
                'Water_Line_Subtype',
                'Water_Line_Material',
                'Installation_Date',
                'Water_Line_Size_Inches',
                'Water_Line_Length_Feet',
              ],
            }),
          };
        }
      },
    });
  }
}

export default MiramarWaterLinesLayer;
